import {createSmartAction} from 'redux-smart-actions';

export const getProfile = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/me',
  },
}));
